import React from "react";
import { useState, useRef } from "react";
import {
  Card,
  Typography,
  Grid,
  TextField,
  Stack,
  InputAdornment,
  Box,
  Input,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
} from "@mui/material";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";

const FormCard = ({
  title,
  fields,
  onFileChange,
  fileName,
  handleButtonClick,
  buttonText,
  radioOptions,
  selectedType,
  setSelectedType,
  selectOptions,
}) => {
  const [formValues, setFormValues] = useState({});
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    if (onFileChange) {
      onFileChange(event);
    }
    setFormValues({
      ...formValues,
      fileName: event.target.files[0]?.name || "No file chosen",
    });
  };

  const handleFileButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFieldChange = (event, field) => {
    setFormValues({ ...formValues, [field]: event.target.value });
  };

  const resetForm = () => {
    setFormValues({});
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    if (onFileChange) {
      onFileChange({ target: { files: [] } });
    }
  };

  return (
    <Card className="shadow p-3" style={{ marginTop: "1rem" }}>
      <Typography variant="h5" fontWeight={700}>
        {title}
      </Typography>
      <Grid container spacing={3} className="mx-0 my-4">
        {fields.map((field, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className="p-0 pe-5 mb-3"
            key={index}
          >
            <Stack spacing={1}>
              <label>{field.label}</label>
              {field.type === "text" && (
                <TextField
                  placeholder={field.placeholder}
                  value={formValues[field.label] || ""}
                  onChange={(e) => handleFieldChange(e, field.label)}
                  InputProps={{
                    style: {
                      borderRadius: "8px",
                    },
                  }}
                />
              )}
              {field.type === "select" && (
                <TextField
                  select
                  label={field.label}
                  value={formValues[field.label] || ""}
                  onChange={(e) => handleFieldChange(e, field.label)}
                  InputProps={{
                    style: {
                      borderRadius: "8px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <img
                          src="/images/arrow-icon.svg"
                          style={{ transform: "rotate(90deg" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  SelectProps={{
                    IconComponent: () => null,
                  }}
                  defaultValue=""
                >
                  {selectOptions[field.label]?.map((option, idx) => (
                    <MenuItem key={idx} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              )}
              {field.type === "radio" && (
                <RadioGroup
                  row
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                >
                  {radioOptions.map((option, idx) => (
                    <FormControlLabel
                      key={idx}
                      value={option.value}
                      control={<Radio />}
                      label={option.label}
                    />
                  ))}
                </RadioGroup>
              )}
              {field.type === "file" && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    border: "1px solid",
                    borderColor: "grey.400",
                    borderRadius: 2,
                  }}
                >
                  <Input
                    type="file"
                    inputRef={fileInputRef}
                    sx={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  <Typography variant="body2" sx={{ flexGrow: 1, padding: 2 }}>
                    {formValues.fileName || "No file chosen"}
                  </Typography>
                  <ButtonTheme
                    variant="contained"
                    color="DarkRed"
                    onClick={handleFileButtonClick}
                    style={{
                      borderRadius: "0px 8px 8px 0px",
                      padding: "15px 30px",
                    }}
                  >
                    Browse
                  </ButtonTheme>
                </Box>
                // <Box display="flex" alignItems="center">
                //   <input
                //     type="file"
                //     id="file-upload"
                //     style={{ display: "none" }}
                //     onChange={onFileChange}
                //   />
                //   <TextField
                //     fullWidth
                //     value={fileName}
                //     InputProps={{
                //       style: {
                //         borderRadius: "8px",
                //         padding: "0",
                //       },
                //       endAdornment: (
                //         <InputAdornment position="end">
                //           <ButtonTheme
                //             variant="contained"
                //             color="DarkRed"
                //             component="label"
                //             htmlFor="file-upload"
                //             style={{
                //               borderRadius: "8px",
                //               padding: "15px 30px",
                //             }}
                //           >
                //             Browse
                //           </ButtonTheme>
                //         </InputAdornment>
                //       ),
                //     }}
                //     placeholder="No file chosen"
                //     InputLabelProps={{ shrink: true }}
                //   />
                // </Box>
              )}
            </Stack>
          </Grid>
        ))}
      </Grid>
      <Box className="d-flex gap-4 mt-3 justify-content-md-start justify-content-center">
        <ButtonTheme
          color="primary"
          component="label"
          className="py-3 px-5 py-md-2 px-md-4"
          onClick={handleButtonClick}
        >
          {buttonText}
        </ButtonTheme>
        <ButtonTheme
          type="button"
          variant="filled"
          disabled
          className="px-3 d-none d-md-block"
          onClick={resetForm}
        >
          Cancel
        </ButtonTheme>
      </Box>
    </Card>
  );
};

export default FormCard;
